import React, { useState, useEffect } from "react";
import { Row, Col, Button, Popover, Badge } from "antd";
import styled from "styled-components";
import Logo from "../../Assets/Images/logo.svg";
import { Menu, Dropdown } from "antd";
import { DownOutlined } from "@ant-design/icons";
import userAvatar from "../../Assets/Icons/user.svg";
import downArrowIcon from "../../Assets/Icons/down-arrow.png";
import paperLoad from "../../Assets/Icons/paper-load2.svg";
import paperRolling from "../../Assets/Icons/tissue-rolling2.svg";
import groupSet from "../../Assets/Icons/group-set2.svg";
import track from "../../Assets/Icons/track2.svg";
import user3 from "../../Assets/Icons/user3.svg";
import question from "../../Assets/Icons/question.svg";
import Iconmoon from "../../Components/IconsFiles/icon";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { getUserProfile, logoutUser } from "../../Services/loginServices";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router";
import stocks from "../../Assets/Icons/stocks_header.svg"
import { useCookies } from 'react-cookie';
import { getImageURL } from "../../Services/deckleMatchServices";
import BellNotifications from "./BellNotifications";
import { closeWebSocket, NOTIFICATION_COUNT_STORAGE_KEY, NOTIFICATION_EVENT } from "../../Services/webSocketService";
const Header = styled.div`
  padding: 8px 36px;
  line-height: 40px;
  background-color: #ffffff;
  border-bottom: 1px solid;
  border-color: rgba(196, 196, 196, 0.5);
  vertical-align: middle;
  top: 0;
  left: 0;
  width: 100%;
  position: sticky;
  z-index: 105;
  .Notification {
    width: 21px;
    height: 21px;
    margin-right: 35px;
    svg {
      width: 21px !important;
      height: 21px !important;
    }
  }
  .Items {
    width: 24px;
    height: 24px;
    margin-right: 35px;
    svg {
      width: 20px !important;
      height: 20px !important;
    }
  }
  .ant-col.ant-col-8.RightHeader {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .avatar {
    width: 30px;
    height: 30px;
    background-image: url(${userAvatar});
    background-size: contain;
    background-repeat: no-repeat;
    margin-right: 12px;
    margin-left: -14px;
  }
  .avatar-cv {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    overflow: hidden;
    object-fit: cover;
  }
  .DropdownList {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    background-color: var(--form-element-bg);
    border: 1px solid #edebe9;
    box-sizing: border-box;
    border-radius: 8px;
    height: 42px;
    line-height: 5px;
    padding: 21px 28px;
    margin-top: 0px;
    position: relative;
    padding-left: 18px;
    margin-left: 15px;
    &:after {
      content: "";
      position: absolute;
      right: 5px;
      top: 18px;
      width: 15px;
      height: 15px;
      background-image: url(${downArrowIcon});
      background-size: contain;
      background-repeat: no-repeat;
    }
  }
  .ant-dropdown-link {
    span {
      font-family: var(--sf-pro-display-m);
      font-style: normal;
      font-size: 12px;
      line-height: 16px;
      color: #000000;
    }
    p {
      font-family: var(--sf-pro-text);
      font-style: normal;
      font-weight: 500;
      font-size: 10px;
      color: #a19f9d;
      letter-spacing: 0.03em;
      line-height: 20px;
      margin-bottom: 4px;
    }
  }
  span.anticon.anticon-down {
    display: none;
  }
  .ant-dropdown ul {
    margin: -53px !important;
    padding: 4px 0;
    top: 55px !important;
    width: 183px !important;
    min-width: 187px;
    left: -39px;
    top: -4px;
  }
  .logo {
    margin-top: 0px;
    width: 140px;
    img {
      width: 100%;
    }
  }
  .ant-dropdown.ant-dropdown-placement-bottomRight {
    left: 1296px !important;
  }
  a.ant-dropdown-trigger.ant-dropdown-link {
    margin-top: 7px;
  }
  a.ant-dropdown-link {
    margin-top: 4px;
  }
  .header-menu {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding-left: 20px;
    padding-right: 20px;
    a {
      font-family: var(--sf-pro-display-m);
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 45px;
      color: #a19f9d;
      padding-left: 20px;
      padding-right: 20px;
      &:hover {
        color: #ea655b;
      }
    }
    .current {
      color: #ea655b;
    }
  }
  .RightHeader {
    > a {
      margin: 0px 20px;
      > div {
        margin: 0 auto;
      }
    }
    .login-button {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      background-color: transparent;
      border: 1px solid #edebe9;
      box-sizing: border-box;
      border-radius: 8px;
      height: 42px;
      padding: 21px 40px;
      margin-top: 0px;
      position: relative;
      padding-left: 50px;
      margin-left: 15px;
      a {
        font-family: var(--sf-pro-display-m);
        color: #000000;
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 30px;
        &:before {
          content: "";
          position: absolute;
          left: 10px;
          top: 6px;
          width: 30px;
          height: 30px;
          background: #fdf0ef;
          background-image: url(${user3});
          background-size: contain;
          background-repeat: no-repeat;
          border-radius: 100px;
        }
        &:after {
          content: "";
          position: absolute;
          left: 105px;
          top: 14px;
          width: 15px;
          height: 15px;
          background-image: url(${downArrowIcon});
          background-size: contain;
          background-repeat: no-repeat;
          transform: rotate(-90deg);
        }
      }
    }
  }
`;

const HeaderNav = (props) => {
  const [currentUser, setCurrentUser] = useState();
  const navigate = useNavigate();
  const location = useLocation();
  const [cookies, setCookie, removeCookie] = useCookies([]);
  const userDetails = JSON.parse(localStorage.getItem("user-details"));
  const [notificationLength, setNotificationLength] = useState(0);
  const logoutHandler = () => {
    // Close WebSocket connection before logout
    closeWebSocket();
    removeCookie("accessToken", { path: "/" });
    removeCookie("rememberMe", { path: "/" });
    removeCookie("loginDateTime", { path: "/" });
    // logoutUser();
    localStorage.clear();
    navigate("/login");
  };

  const menuList = (email) => {
    return (
      <Menu>
        <Menu.Item key="0">
          <Link
            to={{
              pathname: "/profile-setting/general-edit",
              //search: `?email=${email}`,
              //state: { email: email },
            }}
          >
            Edit my profile
          </Link>
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item key="1">
          <div onClick={logoutHandler}>Signout</div>
        </Menu.Item>
      </Menu>
    );
  };

  const dotmenuList = () => {
    return (
      <Menu className="dot-menu-wrap">
        {/* {userDetails.roles.customer_records.edit ||
          userDetails.roles.customer_records.view ||
          userDetails.roles.machine_records.edit ||
          userDetails.roles.machine_records.view ||
          userDetails.roles.product_records.edit ||
          userDetails.roles.product_records.view ||
          userDetails.roles.machine_records.edit ||
          userDetails.roles.machine_records.view}
        ( */}
        <Menu.Item key="0">
          {userDetails.roles.customer_records.edit ||
            userDetails.roles.customer_records.view ? (
            <Link to={{ pathname: "/configuration/global-settings/" }}>
              <div className="d-flex dot-9menu">
                <div class="icon-m">
                  <img
                    src={user3}
                    alt="Order Management"
                    style={{ width: "25px", height: "25px" }}
                  />
                </div>
                <div>
                  <h5>Configurations</h5>
                  <p>Here users can specify Global Settings</p>
                </div>
              </div>
            </Link>
          ) : userDetails.roles.machine_records.edit ||
            userDetails.roles.machine_records.view ? (
            <Link to={{ pathname: "/configuration/customer-records/" }}>
              <div className="d-flex dot-9menu">
                <div class="icon-m">
                  <img
                    src={user3}
                    alt="Order Management"
                    style={{ width: "25px", height: "25px" }}
                  />
                </div>
                <div>
                  <h5>Configurations</h5>
                  <p>Here users can specify Global Settings</p>
                </div>
              </div>
            </Link>
          ) : userDetails.roles.machine_records.edit ||
            userDetails.roles.machine_records.view ? (
            <Link to={{ pathname: "/configuration/machine-records/" }}>
              <div className="d-flex dot-9menu">
                <div class="icon-m">
                  <img
                    src={user3}
                    alt="Order Management"
                    style={{ width: "25px", height: "25px" }}
                  />
                </div>
                <div>
                  <h5>Configurations</h5>
                  <p>Here users can specify Global Settings</p>
                </div>
              </div>
            </Link>
          ) : userDetails.roles.product_records.edit ||
            userDetails.roles.product_records.view ? (
            <Link to={{ pathname: "/configuration/products-records/" }}>
              <div className="d-flex dot-9menu">
                <div class="icon-m">
                  <img
                    src={user3}
                    alt="Order Management"
                    style={{ width: "25px", height: "25px" }}
                  />
                </div>
                <div>
                  <h5>Configurations</h5>
                  <p>Here users can specify Global Settings</p>
                </div>
              </div>
            </Link>
          ) : null}
        </Menu.Item>
        {/* ) */}
        <Menu.Item key="1">
          {userDetails.roles.order_records.edit_all ||
            userDetails.roles.order_records.edit_own ||
            userDetails.roles.order_records.view_all ||
            userDetails.roles.order_records.view_own ? (
            // <Col span={6}>
            <Link to={{ pathname: "/order-entry/order-records/" }}>
              <div className="d-flex dot-9menu">
                <div class="icon-m">
                  <img src={paperLoad} alt="Order Management" />
                </div>
                <div>
                  <h5>Order Management</h5>
                  <p>Here users can specify Order Management</p>
                </div>
              </div>
            </Link>
          ) : // </Col>
            userDetails.roles.approve_orders.edit ? (
              <div className="modulesListMain">
                <Link to={{ pathname: "/order-entry/approve-records/" }}>
                  <div className="d-flex dot-9menu">
                    <div class="icon-m">
                      <img src={paperLoad} alt="Order Management" />
                    </div>
                    <div>
                      <h5>Order Management</h5>
                      <p>Here users can specify Order Management</p>
                    </div>
                  </div>
                </Link>
              </div>
            ) : null}
        </Menu.Item>
        <Menu.Item key="2">
          {userDetails.roles.job_cards.edit ||
            userDetails.roles.job_cards.view ||
            userDetails.roles.approve_jobcards.edit ? (
            <Link to={{ pathname: "/deckle-matching/order-records/" }}>
              <div className="d-flex dot-9menu">
                <div class="icon-m">
                  <img src={paperRolling} alt="Deckle Management" />
                </div>
                <div>
                  <h5>Deckle Management</h5>
                  <p>Here users can specify Deckle Management</p>
                </div>
              </div>
            </Link>
          ) : null}
        </Menu.Item>
        <Menu.Item key="3">
          {userDetails.roles.production.job_cards.edit ||
            userDetails.roles.production.job_cards.view ? (
            <Link
              to={{ pathname: "/production-planning/Production-job-cards/" }}
            >
              <div className="d-flex dot-9menu">
                <div class="icon-m">
                  <img src={track} alt="Order Management" />
                </div>
                <div>
                  <h5>Production Planning</h5>
                  <p>Here users can specify Production Planning</p>
                </div>
              </div>
            </Link>
          ) : userDetails.roles.production.jumbo_reels.edit ||
            userDetails.roles.production.jumbo_reels.view ? (
            <Link to={{ pathname: "/production-planning/jumbo-reel-records/" }}>
              <div className="d-flex dot-9menu">
                <div class="icon-m">
                  <img src={track} alt="Order Management" />
                </div>
                <div>
                  <h5>Production Planning</h5>
                  <p>Here users can specify Production Planning</p>
                </div>
              </div>
            </Link>
          ) : userDetails.roles.production.prod_details.edit ||
            userDetails.roles.production.prod_details.view ? (
            <Link to={{ pathname: "/production-planning/production-detail/" }}>
              <div className="d-flex dot-9menu">
                <div class="icon-m">
                  <img src={track} alt="Order Management" />
                </div>
                <div>
                  <h5>Production Planning</h5>
                  <p>Here users can specify Production Planning</p>
                </div>
              </div>
            </Link>
          ) : null}
        </Menu.Item>

        {userDetails.roles.inventory.stocks.edit ||
          userDetails.roles.inventory.stocks.view ? <Menu.Item key="5">
          <Link to={{ pathname: "/stock-management/stock-records/" }}>
            <div className="d-flex dot-9menu">
              <div class="icon-m">
                <img src={stocks} alt="Stock Management" />
              </div>
              <div>
                <h5>Stock Management</h5>
                <p>Here users can specify Stock Management</p>
              </div>
            </div>
          </Link>
        </Menu.Item> : null}

        <Menu.Item key="6">
          {userDetails.roles.company_profile.edit ||
            userDetails.roles.company_profile.view ||
            userDetails.roles.plan_details_and_billing.edit ||
            userDetails.roles.plan_details_and_billing.view ||
            userDetails.roles.user_management.edit ||
            userDetails.roles.user_management.view ? (
            <Link
              to={{ pathname: "/organization-setting/company-information/" }}
            >
              <div className="d-flex dot-9menu">
                <div class="icon-m">
                  <img
                    src={groupSet}
                    alt="Organization Settings"
                    style={{ width: "25px", height: "25px" }}
                  />
                </div>
                <div>
                  <h5>Organization Settings</h5>
                  <p>Here users can specify Organization Settings</p>
                </div>
              </div>
            </Link>
          ) : null}
        </Menu.Item>
      </Menu>
    );
  };
//Body of notification
  const content = () => {
    const value= [{
      id: 1,
      name: "New order #4587 requires your approval",
      tag: "Order Approval Request",
      time: "5 mins ago",
      type: "alert",
      isRead: false,
    },
    {
      id: 1,
      name: "New order #4587 requires your approval",
      tag: "Order Approval Request",
      time: "5 mins ago",
      type: "event",
      isRead: false,
    },
    {
      id: 1,
      name: "New order #4587 requires your approval",
      tag: "Order Approval Request",
      time: "5 mins ago",
      type: "alert",
      isRead: true,
    }
  ];
    return (
      <div
        style={{
          padding: "8px 6px",
          border: "1px",
          width: "400px",
          // height: "250px",
          borderRadius: "8px",
          display: "flex",
          gap:'8px',
          flexDirection: "column",
        }}
      >
         <div style={{display:'flex',justifyContent:'space-between',paddingBottom:'5px'}}>
        <span style={{color:'#605E5C',fontSize:'14px',fontWeight:'400'}}>NOTIFICATIONS</span>
        <span style={{color:'#EA655B',fontSize:'14px',fontWeight:'400'}}>2 New Notifications</span>
        </div>
       {value.map((value, index) => {
        return(<>
        
        <div
      key={value.id}
      style={{
        display: "flex",
        alignItems: "center",
        width: "100%",
        height: "97px",
        borderLeft: value.isRead
          ? "4px solid #F3F2F1"
          : value.type === "alert"
          ? "4px solid #EA655B"
          : "4px solid #0268D9",
        backgroundColor: value.isRead ? "white" : "#FAF9F8",
        borderRadius: "5px",
        margin: "0.8% 0%",
        padding: "0.8%",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          justifyContent: "space-between",
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          {value.type === "alert" ? (
            <Iconmoon icon="warning-icon" size={16} color="#EA655B" />
          ) : value.type === "event" ? (
            <Iconmoon icon="info_new" size={16} color="#0268D9" />
          ) : (
            <Iconmoon icon="bell" size={16} color="gray" />
          )}
          <p
            style={{
              marginLeft: "10px",
              fontWeight: 700,
              fontSize: "14px",
              color: "black",
              paddingTop: "10px",
            }}
          >
            {value?.name}
          </p>
        </div>
        {value.isRead&&
        <div style={{ display: "flex", alignItems: "center",columnGap:'3px' }}>
          <div style={{ display: "flex", alignItems: "center",flexDirection:'column',justifyContent:'space-around' }}>
          <Iconmoon icon="seen" size={16} color="gray" />
          </div>
          <span style={{ fontSize: "12px", fontWeight: "400",color:'gray' }}>Seen</span>
        </div>}
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          justifyContent: "space-between",
          // marginTop: "10px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexDirection: "row",
            width: "100%",
          }}
        >
          <span
            style={{
              borderRadius: "40px",
              border: "1px solid #D2D0CE",
              padding: "5px 8px",
              backgroundColor: "#F3F2F1",
              color: "#605E5C",
              fontWeight: "400",
              fontSize: "12px",
            }}
          >
            {value?.tag}
          </span>
          <span style={{ fontSize: "12px", fontWeight: "700" }}>
            <Iconmoon icon="clock" size={16} color="#A19F9D" /> {value?.time}
          </span>
        </div>
      </div>
    </div>
        </>)
      })}
      <div style={{display:'flex',justifyContent:'center',width:'100%'}}>
        <Button className="textTypeBtn textBtnIcon" style={{color:'#EA655B',border:'none'}} onClick={()=>navigate('/all-notification')}>View all notifications</Button>
      </div>
      </div>
    );
  };

  //Fetch the details of current logged in user
  const fetchCurrentUser = () => {
    try {
      //const userResponse = await getUserProfile();
      const userResponse = JSON.parse(localStorage.getItem("user-details"));
      let body = {
        bucket_key: userResponse.profile_picture,
        operation: "download"
      };
      if (userResponse.profile_picture) {
        getImageURL(body).then(url => {
          setCurrentUser({
            ...userResponse,
            profile_picture: url,
          });
        });
      } else {
        setCurrentUser(userResponse);
      }
    } catch (error) {
      console.log(error.response);
    }
  };
useEffect(() => {
        const cachedUnreadCount = Number(
          localStorage.getItem(NOTIFICATION_COUNT_STORAGE_KEY) || 0
        );
        setNotificationLength(cachedUnreadCount);
        const handleNotificationEvent = (event) => {
            const { unreadCount } = event.detail;
            setNotificationLength(unreadCount);
        };

        window.addEventListener(NOTIFICATION_EVENT, handleNotificationEvent);

        return () => {
            window.removeEventListener(NOTIFICATION_EVENT, handleNotificationEvent);
        };
    }, []);

  // useEffect(() => {
  //   const fetchNotifications = async () => {
  //     try {
  //       const res = await getAllNotifications();
  //       const unread = res.notifications.filter((item) => !item.read_status);
  //       //setNotificationLength(unread.length);
        
  //     } catch (err) {
  //       console.error(err);
  //     }
  //   };

  //   // Fetch immediately once
  //   fetchNotifications();

  //   // Then auto-refresh every 60 seconds
  //   const interval = setInterval(fetchNotifications, 60000);

  //   // Clear interval on unmount to prevent memory leaks
  //   return () => clearInterval(interval);
  // }, []);

  useEffect(() => {
    fetchCurrentUser();
  }, [localStorage]);


  return (
    <Header className="header-section" style={{ backgroundColor: "#ffffff" }}>
      <Row>
        <Col span={8}>
          {/* <Link to="/landing/"> */}
          <div className="logo">
            <Link to="/landing/">
              <img src={Logo} alt="HaberERP" />
            </Link>
          </div>
          {/* </Link> */}
        </Col>
        <Col span={8}>
          {currentUser && (
            <div className="header-menu">
              <Link
                className={
                  location.pathname.includes("landing") ? "current" : ""
                }
                to="/landing"
              >
                Home
              </Link>
              <Link
                className={
                  location.pathname.includes("contact-us") ? "current" : ""
                }
                to="/contact-us"
              >
                Contact Us
              </Link>
              <Link
                className={
                  location.pathname.includes("feedback") ? "current" : ""
                }
                to="/feedback"
              >
                Feedback
              </Link>
            </div>
          )}
        </Col>
        <Col span={8} className="RightHeader">
          <Link to="/user-guide">
            <div className="Notification" >
              <img
                src={question}
                style={{ width: "27px", position: "relative", top: "-8px" }}
              />
            </div>
          </Link>
          {currentUser && (
            <Popover content={<BellNotifications />} trigger={["click"]}>
              <div className="Notification">
                <Badge size="default" count={notificationLength} color="#EA655B">
                  <Iconmoon icon="bell" size={24} color="#605E5C" />
                </Badge>
              </div>
            </Popover>
          )}
          {currentUser && (
            <Link to="#">
              <Dropdown
                overlay={dotmenuList}
                trigger={["click"]}
                className="drop-menu notation-menu"
              >
                <div className="Items">
                  <Iconmoon icon="menu" size={24} color="#605E5C" />
                </div>
              </Dropdown>
            </Link>
          )}
          {currentUser ? (
            <Dropdown
              overlay={menuList(currentUser.email)}
              trigger={["click"]}
              className="drop-menu"
            >
              <div className="DropdownList">
                {currentUser.profile_picture ? (
                  <img
                    className="avatar-cv"
                    src={`${currentUser.profile_picture}`}
                    style={{
                      width: "30px",
                      height: "30px",
                      marginRight: "12px",
                      marginLeft: "-14px",
                    }}
                    alt="No image"
                  />
                ) : (
                  <div className="avatar"></div>
                )}
                <div
                  className="ant-dropdown-link"
                  onClick={(e) => e.preventDefault()}
                >
                  <span> {currentUser.name}</span>
                  {/* <p>{currentUser.role_type == "SUPER_ADMIN" ? "SUPER" : currentUser.role_type}  - Haber Water</p> */}
                  <p>
                    {currentUser?.role_type?.replace("_", " ")} - Haber Water
                  </p>
                  <DownOutlined />
                </div>
              </div>
            </Dropdown>
          ) : (
            <div className="login-button">
              <Link to="/login">Login</Link>
            </div>
          )}
        </Col>
      </Row>
    </Header>
  );
};
export default HeaderNav;
